<template>
  <div class="row">
    <label class="col-5">{{ label }}</label>

    <input
      type="text"
      :name="name"
      :value="value"
      :placeholder="placeholder"
      class="form-control col-6"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>
<script>
export default {
  name: 'TextInput',
  props: ['placeholder', 'label', 'name', 'value', 'disabled'],
  methods: {},
}
</script>

<style scoped>
.row {
  align-items: center;
  align-content: center;
}
</style>
